import { ITypedReduxAction } from '../../types/redux/actionType';
import { EWidgetStatus } from '../../types/redux/layout';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const SET_WIDGET_STATUS = 'PAYMENT_WIDGET :: LAYOUT :: SET_STATUS';

export type TSetWidgetStatusAction = ITypedReduxAction<typeof SET_WIDGET_STATUS, EWidgetStatus>;

export const setWidgetStatus: (payload: EWidgetStatus) => TSetWidgetStatusAction = actionGenerator<
  typeof SET_WIDGET_STATUS,
  EWidgetStatus
>(SET_WIDGET_STATUS);
